<template>
    <el-dialog v-model="dialogVisible" width="30%" :show-close="false" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="text-box">
            <img src="../../assets/images/login/I.png">
            <span class="title-text">{{ detatildata.title }}</span>
        </div>
        <div>{{ detatildata.meassage }}</div>
        <div class="dialog-footer">
            <el-button v-if="btnFlag" @click="cancel">{{$t('universality.cancel')}}</el-button>
            <!-- <el-button type="primary" :style="{background:(dialogVisible?setStyle():setStyle())}" @click="confirm">确 定</el-button> -->
            <el-button type="primary" :style="{background:setStyle.bakcground,border: setStyle.border}" @click="confirm">{{$t('universality.confirm')}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { nextTick } from 'process'
import { defineComponent, computed, reactive, onMounted, toRefs,watch } from 'vue'
import { deletemap } from '@/apis/building'
export default defineComponent({
    emits:['setdata','cancelvisibles'],
    props: {
        dialogVisibles: {
            type: Boolean,
            default: false
        },
        msg: {
            type: String,
            default: ''
        },
        // 是否右上角关闭按钮  
        showClone: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '提示'
        },
        // 是否需要取消按钮
        btnFlag: {
            type: Boolean,
            default: true
        },
        buttonColor: {
            type: String,
            default: ''
        },
        borderColor: {
            type: String,
            default: ''
        },
        isShow: {
            type: Boolean,
            default: true
        },
        detatildata:{
            type: Object,
            default:{}
        }
    },
    setup(props, {emit}) {
        const state = reactive({
            meassg: '',
            dialogVisible:false,
            title:'',
            detatildata:{
                distinction:'',
                ID:''
            }
        })
        const methods = reactive({
            // 弹窗右上角关闭按钮
            handleClose() {
                // state.dialogVisible = false
                emit('cancelvisibles')
            },
            cancel() {
                // state.dialogVisible = false
                emit('cancelvisibles')
            },
            confirm() {
                emit('setdata')
            },
        })

        const setStyle = reactive({
            bakcground: `${props.buttonColor}`,
            border: `${props.buttonColor}`
        })
        onMounted(()=>{
            state.dialogVisible = props.dialogVisibles
            state.detatildata = props.detatildata
            console.log(state.detatildata,state.dialogVisible)
           nextTick(()=>{
             watch(props,(newold)=>{
                // console.log(newold,props)
                state.dialogVisible = props.dialogVisibles
                state.detatildata = props.detatildata
                // methods.getdetails()
            },
            {deep:true},
            )
           })
        })
        return {
            ...toRefs(state),
            ...toRefs(methods),
            setStyle
        }
    }
})
</script>

<style scoped>
.dialog-footer {
    text-align: right;
    margin-top: 30px;
}

.reds{
    background: red;
}
.text-box {
    padding: 20px 20px 10px;
    position: relative;
    top: -20px;
    left: -20px;
    display: flex;
    align-items: center;
    height: 22px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8500);
    line-height: 22px;
}

.title-text {
    margin-left: 10px;
}
</style>